import Edu_schemesModel from '../Apis/Edu_schemes'
import Controller from './Controller'

export default class Edu_schemesController extends Controller {
  constructor() {
    super(new Edu_schemesModel())
  }

  async getCourse(id) {
    const response = await this.model.getCourse(id)
    return response
  }
  async getOnlineClass(params){
    const response = await this.model.getOnlineClass(params)
    return response
  }
  async getShareContents(data){
    const res = await this.model.getShareContents(data)
    return this.Poup(res);
  }
}
